// @ts-nocheck
import axios from '../utils/axios';
import { ONLINE_REPORT_SERVICE_API_ENDPOINT, REPORT_API_ENDPOINT } from '../config';
import { catchAsync, generateRequestParams, paramsSerializer } from '../utils/api';

export const searchTicket = catchAsync(async ({ filters }) => {
    const query = generateRequestParams(filters);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/quick-bet-search?${query}`);

    return result.data;
});

export const getTicketSelections = catchAsync(async ({ ticketId }) => {
    const result = await axios.get(`${REPORT_API_ENDPOINT}/ticket/${ticketId}/selections`);

    return result.data;
});

export const getPaymentHistory = catchAsync(async ({ params }) => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/payment-order?${query}`);

    return result.data;
});

export const getBetMonitorReports = catchAsync(async ({ params, cancelToken }) => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/online-reports/bets/monitoring?${query}`, {
        cancelToken,
    });

    return result.data;
});

export const getMoneyTransactionsReports = catchAsync(async ({ filters }) => {
    const query = generateRequestParams(filters);
    const result = await axios.get(`${REPORT_API_ENDPOINT}/reports/money-transaction?${query}`);

    return result.data;
});

export const getGamingActivityReports = catchAsync(async ({ params, cancelToken }) => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/game-activity?${paramsSerializer(params)}`, {
        cancelToken,
    });

    return result.data;
});

// export const fetchOpenBets = catchAsync(async ({ filters }) => {
//     const query = generateRequestParams(filters);
//     const result = await axios.get(`${REPORT_API_ENDPOINT}/reports/open-bets?${query}`);
//
//     return result.data;
// });

const getAccountingReports = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/accounting?${query}`);

    return result.data;
});

const getLoginHistoryInfo = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/auth/login-history?${query}`);

    return result.data;
});

const getPlayerActivityReports = catchAsync(async params => {
    const query = generateRequestParams(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/playerActivity?${query}`);

    return result.data;
});

export const getTaxReturnReport = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/tax-return-reports`, { params });

    return result.data;
});

export const getUserBasedTaxReturnReport = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/tax-return-reports/day`, { params });

    return result.data;
});

export const getTaxTurnoverReport = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/tax-turnover-reports`, { params });

    return result.data;
});

export const getUserBasedTaxTurnoverReport = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/tax-turnover-reports/day`, { params });

    return result.data;
});

const getOnlinePlayersReport = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/onlinePlayers?${query}`);

    return result.data;
});

export const getNetCashReport = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/netCash?${query}`);

    return result.data;
});
export const getNetCashLog = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/netCash/log?${query}`);

    return result.data;
});

export const getFrozenAccount = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/frozen?${query}`);

    return result.data;
});

const getRegistrationsHistoryReports = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/registration-history?${query}`);

    return result.data;
});

export const getSportPerformanceReport = catchAsync(async (params, cancelToken) => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/sport-performance-reports/all?${query}`, {
        cancelToken,
    });

    return result.data;
});

export const getMoneyTransaction = catchAsync(async params => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/moneyTransaction?${query}`);

    return result.data;
});

export const getDetails = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/moneyTransaction/details`, { params });

    return result.data;
});

export const getInactivePlayers = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/inactive`, { params });

    return result.data;
});
export const getAuditTrailReport = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/audit-trail-report/logs`, { params });

    return result.data;
});

export const getBetsHistoryDownloadProgress = catchAsync(async params => {
    const result = await axios.get(
        `${ONLINE_REPORT_SERVICE_API_ENDPOINT}/online-reports/bets/history/download/progress`,
        { params },
    );

    return result.data;
});

export const checkFileReady = catchAsync(async uuid => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/file-export/check/${uuid}`);

    return result.data;
});

export const getMoneyTransactionsDownloadProgress = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/moneyTransaction/download/all`, {
        params,
        paramsSerializer,
    });

    return result.data;
});

export const getGamingActivityDownloadProgress = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/game-activity/download-all`, {
        params,
        paramsSerializer,
    });

    return result.data;
});

export const getLoginsHistoryDownloadProgress = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/auth/login-history/download-all`, {
        params,
        paramsSerializer,
    });

    return result.data;
});

export const getPlayerSearchDownloadProgress = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/reports/download-all`, {
        params,
        paramsSerializer,
    });

    return result.data;
});

export const getTicketOperationsHistory = catchAsync(async ({ params, cancelToken }) => {
    const query = paramsSerializer(params);
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/ticket-operations?${query}`, { cancelToken });

    return result.data;
});

const ReportsService = {
    searchTicket,
    getTicketSelections,
    getBetMonitorReports,
    // fetchOpenBets,
    getMoneyTransactionsReports,
    getGamingActivityReports,
    getAccountingReports,
    getLoginHistoryInfo,
    getPlayerActivityReports,
    getPaymentHistory,
    getTaxReturnReport,
    getUserBasedTaxReturnReport,
    getTaxTurnoverReport,
    getUserBasedTaxTurnoverReport,
    getOnlinePlayersReport,
    getNetCashReport,
    getNetCashLog,
    getFrozenAccount,
    getRegistrationsHistoryReports,
    getMoneyTransaction,
    getDetails,
    getInactivePlayers,
    getSportPerformanceReport,
    getAuditTrailReport,
    getBetsHistoryDownloadProgress,
    checkFileReady,
    getMoneyTransactionsDownloadProgress,
    getGamingActivityDownloadProgress,
    getLoginsHistoryDownloadProgress,
    getPlayerSearchDownloadProgress,
    getTicketOperationsHistory,
};

export default ReportsService;
